import React, { useState } from 'react';
import { captureCanvas } from '../utils/pdfExport';

const CanvasTest = () => {
  const [testImage, setTestImage] = useState(null);
  const [isCapturing, setIsCapturing] = useState(false);

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const testCanvasCapture = async () => {
    setIsCapturing(true);
    try {
      const canvas = document.querySelector('canvas');
      console.log('Found canvas:', canvas);
      
      if (canvas) {
        console.log('Canvas dimensions:', canvas.width, 'x', canvas.height);
        const imageDataUrl = await captureCanvas(canvas);
        setTestImage(imageDataUrl);
        console.log('Test capture successful, image length:', imageDataUrl?.length);
      } else {
        console.error('No canvas found');
      }
    } catch (error) {
      console.error('Test capture failed:', error);
    } finally {
      setIsCapturing(false);
    }
  };

  return (
    <div className="fixed top-4 right-4 bg-green-100 border border-green-300 rounded-lg p-3 text-sm z-40 max-w-xs">
      <div className="font-medium text-green-800 mb-2">
        🎨 Canvas Capture Test
      </div>
      
      <button
        onClick={testCanvasCapture}
        disabled={isCapturing}
        className="bg-green-200 hover:bg-green-300 disabled:opacity-50 px-3 py-1 rounded text-green-800 text-xs mb-2 w-full"
      >
        {isCapturing ? 'Capturing...' : 'Test Canvas Capture'}
      </button>
      
      {testImage && (
        <div className="mt-2">
          <div className="text-xs text-green-700 mb-1">Captured:</div>
          <img 
            src={testImage} 
            alt="Canvas test" 
            className="w-full h-20 object-cover border border-green-300 rounded"
          />
          <div className="text-xs text-green-600 mt-1">
            Size: {Math.round(testImage.length / 1024)}KB
          </div>
        </div>
      )}
    </div>
  );
};

export default CanvasTest;